import { META_PIXEL_ID } from '../config'

let vendorScriptsInitialized = false

/**
 * Load the Meta Pixel script and initialize fbq. Called once at module load.
 * Silently swallows errors caused by ad-blockers.
 */
export function initVendorScripts(): void {
  if (vendorScriptsInitialized) return
  vendorScriptsInitialized = true

  if (typeof window === 'undefined') return

  // GTM and Consent Mode v2 defaults are bootstrapped in public/index.html.
  // Ensure dataLayer + gtag exist as a safety fallback.
  window.dataLayer = window.dataLayer || []
  if (!window.gtag) {
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments as unknown as Record<string, unknown>)
    }
  }

  if (META_PIXEL_ID) {
    try {
      /* eslint-disable @typescript-eslint/no-explicit-any */
      const w = window as any
      if (!w.fbq) {
        const n: any = function () {
          if (n.callMethod) {
            // eslint-disable-next-line prefer-rest-params
            n.callMethod.apply(n, arguments)
          } else {
            // eslint-disable-next-line prefer-rest-params
            n.queue.push(arguments)
          }
        }
        w.fbq = n
        if (!w._fbq) w._fbq = n
        n.push = n
        n.loaded = true
        n.version = '2.0'
        n.queue = []
        const t: HTMLScriptElement = document.createElement('script')
        t.async = true
        t.src = 'https://connect.facebook.net/en_US/fbevents.js'
        const s = document.getElementsByTagName('script')[0]
        if (s && s.parentNode) s.parentNode.insertBefore(t, s)
      }
      /* eslint-enable @typescript-eslint/no-explicit-any */

      window.fbq('init', META_PIXEL_ID)
    } catch {
      // Blocked by ad blocker — non-critical
    }
  }
}

export function applyGrant(): void {
  if (typeof window === 'undefined') return

  window.gtag?.('consent', 'update', {
    ad_storage: 'granted',
    analytics_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
  })

  if (window.fbq) {
    window.fbq('consent', 'grant')
    window.fbq('track', 'PageView')
  }
}

export function applyDeny(): void {
  if (typeof window === 'undefined') return

  window.gtag?.('consent', 'update', {
    ad_storage: 'denied',
    analytics_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  })

  if (window.fbq) {
    window.fbq('consent', 'revoke')
  }
}
